export const screenWidth = () => {
  if (window?.innerWidth > 768 && window?.innerWidth < 1268) {
    return "tab";
  } else if (window?.innerWidth < 768) {
    return "mobile";
  } else return "desktop";
};
